import { useTranslation } from "react-i18next";
// Components
import { SessionsHeaderMainDiv, SessionsHeaderDiv, SessionTitle } from "./styles";

const SessionsHeader = () => {
  const [t] = useTranslation("global");

  return (
    <SessionsHeaderMainDiv>
      <SessionsHeaderDiv>
        <SessionTitle width={"100px"} textAlign>
          {t("session").toUpperCase()}
        </SessionTitle>
        <SessionTitle width={"170px"} textAlign>
          {t("date").toUpperCase()}
        </SessionTitle>
        <SessionTitle width={"170px"} textAlign>
          {t("rgsicu_startTime").toUpperCase()}
        </SessionTitle>
        <SessionTitle width={"170px"} textAlign>
          {t("rgsicu_endTime").toUpperCase()}
        </SessionTitle>
        <SessionTitle width={"170px"} textAlign>
          {t("rgsicu_totalTime").toUpperCase()}
        </SessionTitle>
        <SessionTitle width={"80px"} textAlign>
          {t("reports").toUpperCase()}
        </SessionTitle>
      </SessionsHeaderDiv>
    </SessionsHeaderMainDiv>
  );
};

export default SessionsHeader;
